/**
 * Single source of truth for the `ownedByMe=true` query-param literal used by
 * the eight catalog list pages when rendered inside `MyResponsibilities`
 * (spec catalog-ownership/§6.1). Centralising the literal keeps every call
 * site clean and gives one search hit when the contract evolves.
 */
export const OWNED_BY_ME_TRUE = 'true'
